import { createPinia } from 'pinia'

import { makePageSingleton } from '@app/adapters/singleton/page'

export default makePageSingleton(createPinia)
